"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.svgIconOverrides = void 0;
var svgIconOverrides = {
  components: {
    MuiSvgIcon: {
      variants: [{
        props: {
          fontSize: 'huge'
        },
        style: {
          fontSize: '130px'
        }
      }]
    }
  }
};
exports.svgIconOverrides = svgIconOverrides;